import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { ventrisConfig } from "../ventris.config";

type EulaAgreementModalProps = {
  user: any;
};

function EulaAgreementModal({ user }: EulaAgreementModalProps) {
  const [accepted, setAccepted] = useState(!!user?.accepted_eula);
  const eulaPdfUrl = `${process.env.PUBLIC_URL || ""}/eula.pdf`;

  useEffect(() => {
    setAccepted(!!user?.accepted_eula);
  }, [user?.accepted_eula]);

  const decline = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("portal");
    sessionStorage.removeItem("current_user");
    document.location.href = "/";
  };

  const accept = async () => {
    const token = sessionStorage.getItem("token");
    const response = await fetch(ventrisConfig.url + "/api/accept-eula", {
      method: "post",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token,
      },
    });

    if (!response.ok) {
      return;
    }

    const currentUser = JSON.parse(sessionStorage.getItem("current_user") || "{}");
    currentUser.accepted_eula = true;
    sessionStorage.setItem("current_user", JSON.stringify(currentUser));
    setAccepted(true);
  };

  return (
    <Modal show={!!user?.id && !accepted} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>End User License Agreement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please review and accept the below terms of use to continue using the app:</p>
        <div className="eula">
          <iframe src={eulaPdfUrl} className="eula-pdf" title="End User License Agreement PDF" />
        </div>
        <div className="eula-pdf-fallback">
          <a href={eulaPdfUrl} target="_blank" rel="noopener noreferrer">Open the EULA PDF in a new tab</a>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal full-width" onClick={decline}>Decline</Button>
        <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width" onClick={accept}>Accept</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EulaAgreementModal;
